import { render, staticRenderFns } from "./ContentManagement.vue?vue&type=template&id=40f8fea4&scoped=true&"
import script from "./ContentManagement.vue?vue&type=script&lang=js&"
export * from "./ContentManagement.vue?vue&type=script&lang=js&"
import style0 from "./ContentManagement.vue?vue&type=style&index=0&id=40f8fea4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f8fea4",
  null
  
)

export default component.exports